<template>
    <div class="artist-booking-manager-container">
        <div class="artist-events-wrapper">
            <div
                class="artist-event-list-header d-flex justify-content-between align-items-center header-block"
            >
                <div class="d-flex justify-content-between w-100 mt-5 mb-2">
                    <h1>My Events: Calendar</h1>
                    <!-- @TODO Display none ticket 1569 until share avails reimplemented -->
                    <button
                        v-if="width > 600"
                        ref="openModal"
                        v-b-modal.modal-create-event
                        class="check-avails"
                    >
                        Share Avails
                    </button>
                </div>
            </div>
            <div class="divider"></div>
            <div v-if="dataLoaded">
                <booking-legend
                    :artistMode="true"
                    :style="{ 'margin-left': width > 600 ? '50px' : 0 }"
                />
                <BookingCalendar
                    v-if="width > 1000"
                    :events="transformedEvents"
                    :unavails="unavails"
                    @add-unavail="handleAddUnavail"
                    @remove-unavail="handleRemoveUnavail"
                />
                <MobileVenueBookingCalendar
                    v-else
                    :events="transformedEvents"
                    :unavails="unavails"
                    :artistCalendar="true"
                    @add-unavail="handleAddUnavail"
                    @remove-unavail="handleRemoveUnavail"
                />
            </div>
            <div class="event-filter">
                <div class="event-count" v-if="getEvents.length">
                    {{ getEvents.length }} {{ getEvents.length > 1 ? 'Events' : 'Event' }}
                </div>
                <div class="event-count" v-else>No Events</div>
                <div class="d-flex align-items-center" v-if="width > 1000">
                    <span class="filter-text">Showing</span>
                    <div v-for="status in filter" :key="status.id" class="filter-group">
                        <input
                            type="radio"
                            class="radio-check"
                            :id="status.id"
                            :name="'statusGroup'"
                            :checked="status.filterStatus === null"
                            @change="changeStatusFilter(status)"
                            autocomplete="off"
                        />
                        <label :for="status.id" class="filter-by-avails">{{
                            status.label
                        }}</label>
                    </div>
                </div>
                <div class="mobile-select position-relative" v-if="width < 1000">
                    <input
                        type="text"
                        readonly
                        class="mobile-option"
                        v-model="selectedValue"
                        @click="toggleOption"
                    />
                    <i class="fa fa-angle-down fa-2x" v-if="!optionList"></i>
                    <div v-if="optionList" class="option-list">
                        <div
                            v-for="status in filter"
                            :key="status.id"
                            class="option-item"
                            @click="selectOption(status)"
                        >
                            {{ status.label }}
                        </div>
                    </div>
                </div>
            </div>
            <hr style="margin-left: 50px; color: #646464; height: 2px" />
            <button
                v-if="width < 600"
                ref="openModal"
                v-b-modal.modal-create-event
                class="check-avails"
            >
                Share Avails
            </button>
            <div class="artist-event-cards-wrapper">
                <EventCard
                    v-for="event in paginatedArtists"
                    :key="event.event_id"
                    :event="event"
                    variant="artist"
                    @cta-clicked="(event) => goToEventByStatusPage(event)"
                    @card-clicked="(event) => goToEventByStatusPage(event)"
                />
            </div>
            <div v-if="getLengthArtists > 15">
                <Pagination
                    :currentPage="currentPage"
                    :totalPages="totalPages"
                    :visiblePagesCount="getLengthArtists"
                    @page-change="handlePageChange"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import EventCard from '../parts/EventCard.vue'
    import BookingCalendar from './BookingCalendar.vue'
    import sortEventFunction from '../../../mixins/sort-events/sort-artist-events'
    import sortByDateFunction from '../../../mixins/sort-events/sort-by-date'
    import checkScreen from '../../../mixins/check-screen'
    import MobileVenueBookingCalendar from '../parts/MobileVenueBookingCalendar.vue'
    import Pagination from '../../search-result-artist/Pagination.vue'
    import BookingLegend from '../parts/BookingLegend.vue'
    const bidStatusDefinitions = {
        Null: null,
        New: 0,
        Process: 1,
        WaitApprove: 2,
        Confirmed: 3,
        Completed: 4,
        Cancelled: 5,
        Rejected: 6
    }
    const bidArtistStatusDefinitions = {
        Null: null,
        New: 0,
        SaveForLater: 1,
        Ignore: 2,
        Selected: 3,
        Rejected: 4
    }
    const URLS = {
        redirect: {
            makeOffer: '/make-offer',
            opportunities: '/opportunities',
            artistAdvance: '/booking-manager/artist/advance',
            artistWrapup: '/booking-manager/artist/wrap-up',
            artistCompleted: '/booking-manager/artist/completed-history'
        }
    }

    export default {
        name: 'ArtistEventList',
        mixins: [sortEventFunction, checkScreen, sortByDateFunction],
        components: {
            EventCard,
            Pagination,
            MobileVenueBookingCalendar,
            BookingCalendar,
            BookingLegend
        },
        data: () => ({
            events: [],
            unavails: [],
            transformedEvents: [],
            filterStatus: null,
            dataLoaded: false,
            currentPage: 1,
            perPage: 15,
            filter: [
                {
                    filterStatus: null,
                    id: 'filterAll',
                    label: 'All'
                },
                {
                    filterStatus: 1,
                    id: 'Book',
                    label: 'Get Booked'
                },
                {
                    filterStatus: 2,
                    id: 'Advance',
                    label: 'Advance'
                },
                {
                    filterStatus: 3,
                    id: 'Wrap Up',
                    label: 'Wrap Up'
                },
                {
                    filterStatus: 5,
                    id: 'Cancel',
                    label: 'Cancelled'
                },
                {
                    filterStatus: 4,
                    id: 'Completed',
                    label: 'Completed'
                }
            ],
            optionList: false,
            selectedValue: 'All'
        }),
        watch: {
            width: function () {
                this.filterStatus = null
            },
            filterStatus: function () {
                this.currentPage = 1
            }
        },
        methods: {
            goToEventByStatusPage(event) {
                localStorage.clear()
                localStorage.setItem('eventId', event.event_id)

                switch (event.event_status) {
                    case bidStatusDefinitions.New:
                        return (window.location.href = `${URLS.redirect.opportunities}/?opportunity=${event.event_id}`)
                    case bidStatusDefinitions.Process:
                        if (
                            event.event_artist_status === bidArtistStatusDefinitions.Selected
                        ) {
                            return (window.location.href = URLS.redirect.artistAdvance)
                        }
                        localStorage.setItem('bidArtist', event.bid_artist_id)
                        return (window.location.href = `${URLS.redirect.opportunities}/?opportunity=${event.event_id}`)
                    case bidStatusDefinitions.WaitApprove:
                        if (
                            event.event_artist_status !== bidArtistStatusDefinitions.Selected
                        ) {
                            localStorage.setItem('bidArtist', event.bid_artist_id)
                            return (window.location.href = URLS.redirect.makeOffer)
                        }
                        return (window.location.href = URLS.redirect.artistAdvance)
                    case bidStatusDefinitions.Confirmed:
                        return (window.location.href = URLS.redirect.artistWrapup)
                    case bidStatusDefinitions.Completed:
                        return (window.location.href = `${URLS.redirect.artistCompleted}/${event.event_id}`)
                    default:
                        return
                }
            },
            selectOption(status) {
                this.filterStatus = status.filterStatus
                this.selectedValue = status.label
                this.optionList = false
            },
            toggleOption() {
                this.optionList = !this.optionList
            },
            async getAllArtistEvents() {
                const response = await axios.get('/api/artist/events')
                this.events = this.sortByDateForArtist(response.data.data)
            },
            async getAllArtistUnavailableDates() {
                const response = await axios.get('/api/profile/events')
                let events = response.data.events.data

                events = events.filter((e) => !e.available)
                return events.map((e) => ({
                    ...e,
                    date: this.formatEventDate(e)
                }))
            },
            formatEventDate(event) {
                const originalEventDay = event.date.split('T')[0].split('-')
                const year = originalEventDay[0]
                const month = originalEventDay[1]
                const day = originalEventDay[2]

                return `${month}-${day}-${year}`
            },
            async handleAddUnavail(date) {
                let formattedDate = this.getFormattedDate(date)

                try {
                    const resp = await axios.post('/api/profile/events', {
                        date_from: formattedDate,
                        date_to: formattedDate,
                        start_date_info: formattedDate,
                        end_date_info: formattedDate,
                        price: 0,
                        tour_mode: false,
                        available: false
                    })
                    return resp
                } catch (e) {
                    console.error(e)
                }
            },
            async handleRemoveUnavail(date) {
                let unavails = await this.getAllArtistUnavailableDates()

                let unavailDay = unavails.find((e) => {
                    let eventDate = new Date(e.date)

                    return (
                        eventDate.getYear() === date.getYear() &&
                        eventDate.getMonth() === date.getMonth() &&
                        eventDate.getDate() === date.getDate()
                    )
                })

                if (unavailDay) {
                    try {
                        let resp = await axios.delete('/api/profile/events/' + unavailDay.id)
                        return resp
                    } catch (e) {
                        console.error(e)
                    }
                }
            },
            getFormattedDate(date) {
                let year = date.getFullYear()
                let month = date.getMonth() + 1
                let day = date.getDate()

                return `${year}-${month}-${day}`
            },
            getEventForCalendar() {
                this.getRelevantEvents.forEach((event) => {
                    const eventForCalendar = {
                        title: this.getTitleEvent(event.event_status),
                        start: event.event_date_timestamp,
                        startDate: event.event_full_date,
                        color: this.getColorEvent(event.event_status),
                        url: '/event/manage/' + event.event_id + '/edit',
                        eventId: event.event_id,
                        eventStatus: event.event_status,
                        bidArtist: event.bid_artist_id,
                        artistStatus: event.event_artist_status
                    }
                    this.transformedEvents.push(eventForCalendar)
                })
            },
            getColorEvent(status) {
                if (status === 1) {
                    return '#C9CD00'
                } else if (status === 2) {
                    return '#CB9B1F'
                } else if (status === 3) {
                    return '#D188BF'
                } else if (status === 5) {
                    return '#646464'
                } else if (status === 4) {
                    return '#BA87FF'
                } else if (status === 0) {
                    return '#acacac'
                }
            },
            getTitleEvent(status) {
                if (status === 1) {
                    return 'Book'
                } else if (status === 2) {
                    return 'Advance'
                } else if (status === 3) {
                    return 'WrapUp'
                } else if (status === 5) {
                    return 'Cancelled'
                } else if (status === 4) {
                    return 'Completed'
                } else if (status === 0) {
                    return 'Invited'
                } else if (status === 6) {
                    return 'Rejected'
                }
            },
            handlePageChange(page) {
                this.currentPage = page
            },
            changeStatusFilter(status) {
                this.handlePageChange(1)
                this.filterStatus = status.filterStatus
            }
        },
        computed: {
            totalPages() {
                return Math.ceil(this.getEvents.length / this.perPage)
            },
            paginatedArtists() {
                const startIndex = (this.currentPage - 1) * this.perPage
                const endIndex = startIndex + this.perPage

                if (endIndex > this.getEvents.length) {
                    return this.getEvents.slice(startIndex)
                }

                return this.getEvents.slice(startIndex, endIndex)
            },
            getLengthArtists() {
                return this.getEvents.length
            },
            getRelevantEvents() {
                return this.events.filter(
                    (event) =>
                        event.event_artist_status !== 1 &&
                        event.event_artist_status !== 2 &&
                        event.event_artist_status !== 4
                )
            },
            getEvents() {
                if (this.filterStatus === null) {
                    return this.filterEvents(this.getRelevantEvents)
                } else {
                    if (this.filterStatus === 1) {
                        return this.getRelevantEvents.filter(
                            (event) =>
                                ((event.event_status === 0 || event.event_status === 1) &&
                                    event.event_artist_status === 0) ||
                                event.event_artist_status === null
                        )
                    } else if (this.filterStatus === 2) {
                        return this.getRelevantEvents.filter(
                            (event) =>
                                event.event_status >= 0 &&
                                event.event_status <= 2 &&
                                event.event_artist_status === 3
                        )
                    } else if (this.filterStatus === 3) {
                        return this.getRelevantEvents.filter(
                            (event) =>
                                event.event_status === 3 && event.event_artist_status === 3
                        )
                    } else if (this.filterStatus === 5) {
                        return this.getRelevantEvents.filter(
                            (event) =>
                                event.event_status === 6 ||
                                event.event_status === 5 ||
                                event.event_artist_status === 4
                        )
                    }
                    return this.getRelevantEvents.filter(
                        (event) => event.event_status === this.filterStatus
                    )
                }
            }
        },
        async created() {
            this.unavails = await this.getAllArtistUnavailableDates()

            await this.getAllArtistEvents()
            this.getEventForCalendar()
            this.dataLoaded = true
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../sass/_variables.scss';
    .select-filter {
        display: flex;
        align-items: baseline;
        min-width: max-content;
    }
    .event-count {
        color: #8b8b8b;
        font-family: 'Instrument Sans';
        font-size: 32px;
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: -0.64px;
    }
    .filter-text {
        color: #646464;
        font-family: 'Instrument Sans';
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
    }
    input[type='radio'] {
        height: 20px;
        width: 20px;

        background: inherit;
        appearance: none;
        border: 1px solid #8b8b8b;
        border-radius: 50%;
    }
    input[type='radio']:checked {
        accent-color: #cdeb09;
        appearance: auto;
    }
    .filter-group {
        display: flex;
        padding: 10px 8px;
        align-items: center;
        gap: 8px;
    }
    .filter-by-avails {
        color: #8b8b8b;
        font-family: 'Instrument Sans';
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
    }
    .fa {
        bottom: 23%;
        color: #8b8b8b;
        left: 91%;
        position: absolute;
    }
    .mobile-select {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 6px;
        align-self: stretch;
    }
    .mobile-option {
        display: flex;
        padding: 12px 12px 16px 16px;
        justify-content: center;
        align-items: center;
        gap: 8px;
        align-self: stretch;
        border-radius: 12px;
        border: 1px solid #8b8b8b;
        background: #262626;
        overflow: hidden;
        color: #dedede;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-family: 'Instrument Sans';
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
    }
    .option-list {
        display: flex;
        padding: 12px 16px 16px 16px;
        flex-direction: column;
        align-items: flex-start;
        gap: 20px;
        align-self: stretch;
        border-radius: 12px;
        border: 1px solid #8b8b8b;
        background: #262626;
        position: static;
    }
    .option-item {
        overflow: hidden;
        color: #8b8b8b;
        text-overflow: ellipsis;
        font-family: 'Instrument Sans';
        font-size: 16px;
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
        cursor: pointer;
    }
    .divider {
        margin-left: 50px;
        margin-top: 27px;
        margin-bottom: 68px;
        background: #646464;
        width: 100%;
        height: 1px;
    }
    .filter-by-completed-count {
        border-radius: 100px;
        border: 1.5px solid #646464;
        color: #646464;
        text-align: center;
        font-size: 14px;
        font-family: 'Instrument Sans';
        font-weight: 700;
        line-height: 120%;
        letter-spacing: -0.14px;
        margin-right: 8px;
        padding: 9px 14px;
    }
    .filter-by-cancelled {
        color: #ba87ff;
        font-size: 16px;
        font-family: 'Instrument Sans';
        font-weight: 550;
        line-height: 125%;
        margin-right: 20px;
        cursor: pointer;
    }
    .filter-by-completed {
        color: #646464;
        font-size: 16px;
        font-family: 'Instrument Sans';
        font-weight: 550;
        line-height: 125%;
        margin-right: 20px;
        cursor: pointer;
    }
    .filter-by-advance-count {
        border-radius: 100px;
        border: 1.5px solid #cb9b1f;
        color: #cb9b1f;
        text-align: center;
        font-size: 14px;
        font-family: 'Instrument Sans';
        font-weight: 700;
        line-height: 120%;
        letter-spacing: -0.14px;
        margin-right: 8px;
        padding: 9px 14px;
    }
    .filter-by-cancelled-count {
        border-radius: 100px;
        border: 1.5px solid #ba87ff;
        color: #ba87ff;
        text-align: center;
        font-size: 14px;
        font-family: 'Instrument Sans';
        font-weight: 700;
        line-height: 120%;
        letter-spacing: -0.14px;
        padding: 9px 14px;
        margin-right: 8px;
    }
    .filter-by-wrap-up-count {
        border-radius: 100px;
        border: 1.5px solid #d188bf;
        color: #d188bf;
        text-align: center;
        font-size: 14px;
        font-family: 'Instrument Sans';
        font-weight: 700;
        line-height: 120%;
        letter-spacing: -0.14px;
        padding: 9px 14px;
        margin-right: 8px;
    }
    .filter-by-advance {
        color: #cb9b1f;
        font-size: 16px;
        font-family: 'Instrument Sans';
        font-weight: 550;
        line-height: 125%;
        margin-right: 20px;
        cursor: pointer;
    }
    .filter-by-wrap-up {
        color: #d188bf;
        font-size: 16px;
        font-family: 'Instrument Sans';
        font-weight: 550;
        line-height: 125%;
        margin-right: 20px;
        cursor: pointer;
    }
    .filter-by-all {
        color: #ffffff;
        font-size: 16px;
        font-family: 'Instrument Sans';
        font-weight: 550;
        line-height: 125%;
        margin-right: 20px;
        cursor: pointer;
    }
    .filter-by-invited {
        color: #d7eb5a;
        font-size: 16px;
        font-family: 'Instrument Sans';
        font-weight: 550;
        line-height: 125%;
        margin-right: 20px;
        cursor: pointer;
    }
    .filter-by-invited-count {
        border-radius: 100px;
        border: 1.5px solid #d7eb5a;
        color: #d7eb5a;
        font-size: 14px;
        font-family: 'Instrument Sans';
        font-weight: 700;
        line-height: 120%;
        letter-spacing: -0.14px;
        padding: 9px 14px;
        margin-right: 8px;
    }
    .filter-by-book {
        color: #c9cd00;
        font-size: 16px;
        font-family: 'Instrument Sans';
        font-weight: 550;
        line-height: 125%;
        margin-right: 20px;
        cursor: pointer;
    }
    .filter-by-book-count {
        border-radius: 100px;
        border: 1.5px solid #c9cd00;
        color: #c9cd00;
        font-size: 14px;
        font-family: 'Instrument Sans';
        font-weight: 700;
        line-height: 120%;
        letter-spacing: -0.14px;
        padding: 9px 14px;
        margin-right: 8px;
    }
    .artist-event-list-header {
        margin-left: 50px;
    }
    .event-filter {
        margin-top: 50px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        text-wrap: nowrap;
    }
    .filter-text {
        color: #dedede;
        font-size: 16px;
        font-family: 'Instrument Sans';
        font-weight: 550;
        line-height: 125%;
        margin-right: 35px;
        min-width: max-content;
    }
    .check-avails {
        display: none;
        padding: 13px 40px 15px;
        background: #cdeb09;
        border-radius: 100px;
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 600;
        font-size: 18px;
        line-height: 120%;
        text-align: right;
        letter-spacing: -0.01em;
        color: #000000;
        border: 0;
    }
    h1 {
        color: #dedede;
        font-size: 56px;
        font-family: 'Instrument Sans';
        font-weight: 500;
        line-height: 100%;
        letter-spacing: -2.8px;
    }
    .artist-events-wrapper {
        padding: 25px 0px 140px 0px;
        background: black;
    }
    .artist-booking-manager-container {
        max-width: 1245px;
        margin-left: auto;
        margin-right: auto;
    }
    .artist-event-cards-wrapper {
        margin-left: 50px;
        padding-right: 50px;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
        gap: 20px;
        flex-wrap: wrap;
    }
    @media (min-width: 1400px) {
        .artist-events-wrapper {
            max-width: 1150px;
            margin-left: auto;
            margin-right: auto;
        }
    }
    @media (max-width: 1360px) {
        .event-filter {
            justify-content: center !important;
        }
        .artist-events-wrapper {
            max-width: 1000px;
            margin-left: auto;
            margin-right: auto;
        }
    }
    @media (max-width: 1100px) {
        .event-filter {
            overflow-y: scroll;
            justify-content: flex-start;
        }
    }
    @media (max-width: 1000px) {
        .artist-events-wrapper {
            padding: 0;
        }
        .artist-event-cards-wrapper {
            margin-left: 0;
            padding-right: 0;
            justify-content: center;
        }
        .event-filter {
            flex-direction: column;
            gap: 16px;
            justify-content: flex-start;
            align-items: flex-start;
        }
        h1 {
            font-size: 22px;
        }
        .event-filter {
            overflow-y: scroll;
            justify-content: flex-start;
        }
        .divider {
            width: auto;
            margin-left: 0;
        }
        .artist-event-list-header {
            margin-left: 0;
        }
        .check-avails {
            width: 100%;
            text-align: center;
            display: none;
        }
    }
</style>
